declare var ObjectBase
declare var $

var MenuController = ObjectBase.extend({
    on: function() {
        $(this.trigger)?.sideNav?.();
    }
});

$(document).ready(function() {
    var menuController = new MenuController({
        trigger: '.icone-menu'
    });
    menuController.on();
});
